import { ObservableArray, View } from "binder"
import { NotificationsPopupViewModel, notifications } from "./notificationsPopup-viewModel"

export class NotificationsPopupView extends View<NotificationsPopupViewModel>{
    GetViewUniqueId(): string {
        return "V-BB344EDD-82D5-4139-AE54-F085E4E81D6C"
    }
    loadHtml(): string {
        let element = require('./notificationsPopup.html').default;
        let style = require('./notificationsPopup.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set notifications(v: ObservableArray<notifications>) { this._notifications = v; } public get notifications(): ObservableArray<notifications> { return this._notifications;} private _notifications: ObservableArray<notifications>;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set hasUnseen(v: boolean) { this._hasUnseen = v; } public get hasUnseen(): boolean { return this._hasUnseen;} private _hasUnseen: boolean;
    
    refresh(){
        this.dataContext.refresh();
    }

    showAll(){
        this.dataContext.showAll();
    }
}
